import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import moment from 'moment-timezone';
import { CreateRecurrenceLogsService } from './services/create-recurrence-logs.service';
var TabHistoricComponent = /** @class */ (function () {
    function TabHistoricComponent(dialogData, createRecurrenceLogs) {
        this.dialogData = dialogData;
        this.createRecurrenceLogs = createRecurrenceLogs;
        this.todayDate = moment().format('DD/MM/YYYY');
        this.yesterdayDate = moment().subtract(1, 'days').format('DD/MM/YYYY');
        this.recurrenceLogsMapped = [];
        this.recurrence = this.dialogData.recurrence;
    }
    TabHistoricComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.recurrenceLogsMapped = this.createRecurrenceLogs.listRecurrenceLogsMapped(this.recurrence);
                return [2 /*return*/];
            });
        });
    };
    return TabHistoricComponent;
}());
export { TabHistoricComponent };
